export const setItem = (key, value) => {
    localStorage.setItem(key, value);
};

export const getItem = (key) => {
    const item = localStorage.getItem(key);
    return item ? item : 0;
};

export const removeItem = (key) => {
    localStorage.removeItem(key);
};

export const getItemToken = (key) => {
    const item = localStorage.getItem(key);
    if (!item) return null;

    return {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + item,
    };
}